'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';

import Phone from '@icons/Phone.svg';

import { ColumnContainer, Label } from '@components/Common';
import { Input } from '@components/Input';
import { OnboardingStep } from '@components/Onboarding/TeacherOnboarding/components';
import {
  CountryCodePrefix,
  PhoneInputsContainer,
} from '@components/Onboarding/TeacherOnboarding/styles';

interface PhoneStepProps {
  phone: string;
  setPhone: (value: string) => void;
  error?: boolean;
}

export const PhoneStep: React.FC<PhoneStepProps> = ({ phone, setPhone, error }) => {
  const { t } = useTranslation('common');

  return (
    <OnboardingStep
      stepLabel={t('onboardingTeacher.stepThree')}
      title={t('onboardingTeacher.howToReach')}
      description={t('onboardingTeacher.stepThreeDescription')}
    >
      <ColumnContainer>
        <Label>{t('phoneNumber')}</Label>
        <PhoneInputsContainer>
          <CountryCodePrefix>
            <Phone />
            <>+31</>
          </CountryCodePrefix>
          <Input
            type="phoneNumber"
            id="phoneNumber"
            placeholder={t('enterPhone')}
            name="phoneNumber"
            required
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            hasError={error}
          />
        </PhoneInputsContainer>
      </ColumnContainer>
    </OnboardingStep>
  );
};